module.exports = __webpack_public_path__ + "media/gallery/berlin-1-min-68a8a9fb.webp";